import { Button } from '@pay-com/components'
import { CheckArrowFilled, Logo } from '@pay-com/icons'
import { useTranslation } from 'react-i18next'

type AmendmentSuccessProps = {
  showButton: boolean
  hasMorePricings?: boolean
  onContinue?: () => void
}

export const AmendmentSuccess = ({
  showButton,
  hasMorePricings = false,
  onContinue
}: AmendmentSuccessProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="fixed left-0 top-0 z-10 flex p-6">
        <Logo />
      </div>
      <div className="grid h-screen place-content-center">
        <div className="flex max-w-full flex-col items-center justify-center gap-4 p-4 md:max-w-[29rem]">
          <CheckArrowFilled
            className="size-20 text-green-500"
            fill="currentColor"
          />
          <h1 className="mt-6 text-2xl font-semibold text-blueGray-900 lg:text-2.5xl">
            {t('amendment.success.title')}
          </h1>
          <p className="text-center text-sm leading-7 text-gray-600 md:w-[27rem] lg:text-base">
            {hasMorePricings
              ? t('amendment.success.descriptionMore')
              : t('amendment.success.description')}
          </p>
          {showButton && (
            <Button
              className="mt-5 w-full max-w-fit"
              type="button"
              onClick={onContinue}
            >
              {hasMorePricings
                ? t('amendment.success.signNextButton')
                : t('applicationCompleted.continueButton')}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}
